/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mergeClasses } from "@microsoft/shifts-ui-core";
import * as React from "react";

import { useStyles } from "./Grid.styles";
import { GridProps } from "./GridProps";

/**
 * Renders the Grid component to show children in a two dimensions grid.
 * @param props The properties.
 * @returns The Grid component.
 */
export const Grid: React.FC<GridProps> = props => {
    const { children } = props;
    const styles = useStyles();
    const className = props.className ? mergeClasses(styles.grid, props.className) : styles.grid;

    return <div className={className}>{children}</div>;
};
